import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useSeo, PAGES, graph, crumbs } from "@/lib/seo";
import { fmtDate } from "@/lib/format";
import { RichText } from "@/components/common/RichText";
import { PageHero } from "@/components/common/SectionHeading";
import NotFound from "./NotFound";

export default function Policy({ slug }) {
  const [doc, setDoc] = useState(undefined);
  useEffect(() => {
    setDoc(undefined);
    api.get(`/policies/${slug}`).then((r) => setDoc(r.data)).catch(() => setDoc(null));
  }, [slug]);
  const title = doc?.title || "Policy";
  useSeo({ title: `${title} | Young Spine Tricity`, description: PAGES[`/${slug}`]?.description, path: `/${slug}`, jsonLd: doc ? graph(crumbs([title, `/${slug}`])) : null });
  if (doc === null) return <NotFound />;
  if (doc === undefined) return <div className="container-x py-20"><div className="h-64 animate-pulse rounded-3xl bg-brand-tint" /></div>;
  return (
    <>
      <PageHero eyebrow="Amar Healthcare Solutions" title={doc.title} intro={`Last updated ${fmtDate(doc.updated_at)}`} />
      <div className="container-x py-12 md:py-16">
        <RichText text={doc.body} className="max-w-3xl" />
      </div>
    </>
  );
}
